import React from 'react';
import {
  Route,
  Switch,
} from 'react-router-dom';
import LoginContainer from 'containers/Login';
import AdminBaseContainer from 'containers/Admin';
import AdminLoginContainer from 'containers/AdminLogin';
import VerifyCoachContainer from 'containers/VerifyCoach';
import HomeContainer from 'containers/Home';
import AboutContainer from 'containers/About';
import DashboardContainer from 'containers/Dashboard';
import OurResultsContainer from 'containers/OurResults';
import ContactContainer from 'containers/Contact';
import SportsContainer from 'containers/Sports';
import RegisterContainer from 'containers/Register';
import AthleteContainer from 'containers/Athelete';
import ProfileContainer from 'containers/Profile';
import ProfileViewContainer from 'containers/Profile-view';
import ForgotContainer from 'containers/ForgotPassword';
import ResetContainer from 'containers/Settings';
import CoachRegisterContainer from 'containers/Coach-register';
import DashBoardCoach from 'containers/DashBoardCoach';
import Package from 'containers/Packages';
import PaymentContainer from 'containers/Payment';
import Redirect from 'containers/Redirect';
import AthleteById from 'containers/AthleteById';
import CoachAthleteView from 'containers/CoachAthleteView';
import CoachPage from 'containers/Coach';
import ParentProfile from 'containers/Parents';
import ParentRegister from 'containers/RegisterParent';
import TermsAndUse from 'containers/Terms';
import PublicAthleteContainer from 'containers/PublicAthletePage';

import { About, Settings, Athlete, CoachRegister, Dashboard,
    Contact, OurResults, Forgot, RegisterAthlete, ViewAthlete, Register, Sports, Login,
    ViewAthleteById, CoachDashboard, Payment, Pricing, RedirectPage, AthleteCoachView,
    Parent, Coach, RegisterParent, VerifyCoach, AdminLogin, AdminBase, Terms, AthleteForCoach,
    PublicAthlete,
} from './routeNames';


const routes = (
  <Switch>
    <Route exact path="/" component={HomeContainer} />
    <Route exact path={About} component={AboutContainer} />
    <Route path={Dashboard} component={DashboardContainer} />
    <Route exact path={Contact} component={ContactContainer} />
    <Route exact path={Sports} component={SportsContainer} />
    <Route exact path={OurResults} component={OurResultsContainer} />
    <Route exact path={Login} component={LoginContainer} />
    <Route exact path={Register} component={RegisterContainer} />
    <Route exact path={Athlete} component={AthleteContainer} />
    <Route exact path={`${Athlete}/:id`} component={AthleteById} />
    <Route exact path={`${AthleteCoachView}/:id`} component={CoachAthleteView} />
    <Route exact path={RegisterAthlete} component={ProfileContainer} />
    <Route exact path={ViewAthlete} component={ProfileViewContainer} />
    <Route exact path={ViewAthleteById} component={ProfileViewContainer} />
    <Route exact path={Forgot} component={ForgotContainer} />
    <Route exact path={Settings} component={ResetContainer} />
    <Route exact path={CoachRegister} component={CoachRegisterContainer} />
    <Route exact path={CoachDashboard} component={DashBoardCoach} />
    <Route exact path={Pricing} component={Package} />
    <Route exact path={Payment} component={PaymentContainer} />
    <Route exact path={RedirectPage} component={Redirect} />
    <Route exact path={Parent} component={ParentProfile} />
    <Route exact path={Coach} component={CoachPage} />
    <Route exact path={RegisterParent} component={ParentRegister} />
    <Route exact path={AdminLogin} component={AdminLoginContainer} />
    <Route exact path={VerifyCoach} component={VerifyCoachContainer} />
    <Route exact path={AdminBase} component={AdminBaseContainer} />
    <Route exact path={Terms} component={TermsAndUse} />
    <Route exact path={`${AthleteForCoach}/:id`} component={AthleteById} />
    <Route exact path={PublicAthlete} component={PublicAthleteContainer} />
  </Switch>
);

export default routes;



// WEBPACK FOOTER //
// ./src/common/routes/routes.js